
/**
 * Arquivo responsável por centralizar em forma de constantes
 * as cores utilizadas no sistema.
 */

/**
 * Cores presentes no arquivo colors.scss
 */
export const PRIMARY_PRESSED_COLOR = "#051842";
export const PRIMARY_DANGER_COLOR  = "#B12525";
export const PRIMARY_HOVERED_COLOR = "#0B3289";
export const DARK_GREY_COLOR       = "#333";

/**
 * Cores de status
 */
export const STATUS_DISABLED_COLOR = "#650000";
export const STATUS_CRITICAL_COLOR = "#b12525";
export const STATUS_MAJOR_COLOR    = "#fa5904";
export const STATUS_MINOR_COLOR    = "#dbd20d";
export const STATUS_NORMAL_COLOR   = "#1d9d23";
export const STATUS_UNKNOWN_COLOR  = "#347ac1";

/**
 * Cores do Circuito
 */
export const CIRCUIT_NOT_ACTIVE = "#BDC0CC";

export const CIRCUIT_GRAY   = "#666666";
export const CIRCUIT_GRAY_2 = "#6A6A6A";
export const CIRCUIT_RED    = "#b12525";
export const CIRCUIT_BLUE   = "#0B3289";

/**
 * Outras cores
 */
export const WHITE_COLOR = "#FFFFFF";
export const BLACK_COLOR = "#000000";
export const TRANSPARENT_COLOR = "rgba(0, 0, 0, 0.00)";
export const SHADOW_GRAY_COLOR = "#BDC0CC";
export const CARD_OUTDATED_BG = "#FDE5A7";
